import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';

let UiCStatusResponseComponent = class UiCStatusResponseComponent {
    constructor() {
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit();
    }
    prepareStatusPartners(status) {
        switch (status) {
            case 'WAITING_TO_ACCEPT_TERMS':
                return 'ESPERANDO PARA ACEITAR OS TERMOS';
            case 'WAITING_TO_ACCEPT_TERMS_AND_PASSWORD_SETTING':
                return 'AGUARDANDO ACEITAR OS TERMOS E A CONFIGURAÇÃO DA SENHA';
            case 'FINISHED':
                return 'FINALIZADO';
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusResponseComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusResponseComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusResponseComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusResponseComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusResponseComponent.prototype, "imagePath", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCStatusResponseComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCStatusResponseComponent.prototype, "continue", void 0);
UiCStatusResponseComponent = __decorate([
    Component({
        selector: 'ui-c-status-response',
        template: "<div class=\"animation-type\">\n  <ion-row class=\"ion-justify-content-center ion-align-items-center\">\n    <ion-row class=\"ion-justify-content-center ion-align-items-center\">\n      <ion-col size=\"12\" size-xl=\"4\" class=\"ion-text-center\">\n        <svg-icon [stretch]=\"false\" [src]=\"imagePath\"> </svg-icon>\n      </ion-col>\n      <ion-col size=\"12\">\n        <ion-text class=\"ion-text ion-text-blue ion-text-center\">\n          <h1 [style.color]=\"primaryColor\" class=\"font-size-30\">\n            {{title}}\n          </h1>\n        </ion-text>\n        <ion-text class=\"ion-text ion-text-center\">\n          <p [style.color]=\"secondaryColor\" class=\"font-size-20\">\n            {{description}}\n          </p>\n        </ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-row>\n\n  <ion-row class=\"ion-justify-content-center ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button expand=\"block\" (click)=\"goContinue()\">\n        {{ 'ONBORDING.V2.BUTTON.CONCLUDE' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n"
    })
], UiCStatusResponseComponent);

let UiCStatusResponseModule = class UiCStatusResponseModule {
};
UiCStatusResponseModule = __decorate([
    NgModule({
        declarations: [UiCStatusResponseComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCInputModule,
            AngularSvgIconModule
        ],
        exports: [UiCStatusResponseComponent]
    })
], UiCStatusResponseModule);

export { UiCStatusResponseComponent, UiCStatusResponseModule };
//# sourceMappingURL=wlp-ui-c-status-response.js.map
